module.exports = __webpack_public_path__ + "static/img/pdf1.5bca5719.png";